import { Link } from "react-router-dom";

const LINKS = [
  { to: "/about", label: "About" },
  { to: "/coaching", label: "Coaching" },
  { to: "/pricing", label: "Pricing" },
  { to: "/reviews", label: "Reviews" },
  { to: "/awards", label: "Awards" },
  { to: "/gallery", label: "Gallery" },
  { to: "/contact", label: "Contact" },
];

const Nav = () => (
  <header className="fixed top-0 inset-x-0 z-50">
    <nav
      className="mx-auto max-w-7xl px-5 sm:px-8 mt-4 rounded-3xl lg:rounded-full backdrop-blur-xl bg-sand/70 border border-black/5 shadow-[0_8px_30px_rgb(0,0,0,0.04)]"
      data-testid="main-nav"
    >
      <div className="flex items-center justify-between h-16">
        <Link
          to="/"
          data-testid="nav-logo"
          aria-label="Me 1st Fitness & Coaching — home"
          className="shrink-0"
        >
          <img
            src="/logo.png"
            alt="Me 1st Fitness & Coaching logo"
            className="h-12 lg:h-14 w-auto"
          />
        </Link>

        <div className="hidden lg:flex items-center gap-6">
          {LINKS.map((l) => (
            <Link
              key={l.to}
              to={l.to}
              data-testid={`nav-link-${l.label.toLowerCase()}`}
              className="text-sm font-medium text-charcoal/70 hover:text-charcoal transition-colors duration-200"
            >
              {l.label}
            </Link>
          ))}
          <Link
            to="/contact"
            data-testid="nav-get-started-btn"
            className="rounded-full bg-brand text-charcoal font-bold text-sm px-6 py-2.5 hover:bg-brand-dark hover:text-sand transition-colors duration-300 shadow-[0_4px_16px_rgb(136,206,172,0.45)]"
          >
            GET STARTED
          </Link>
        </div>

        <Link
          to="/contact"
          data-testid="nav-mobile-get-started-btn"
          className="lg:hidden rounded-full bg-brand text-charcoal font-bold text-xs px-4 py-2 hover:bg-brand-dark hover:text-sand transition-colors duration-300"
        >
          GET STARTED
        </Link>
      </div>

      <div
        className="lg:hidden flex items-center gap-5 overflow-x-auto pb-3 [scrollbar-width:none] [&::-webkit-scrollbar]:hidden"
        data-testid="nav-links-strip"
      >
        {LINKS.map((l) => (
          <Link
            key={l.to}
            to={l.to}
            data-testid={`nav-strip-link-${l.label.toLowerCase()}`}
            className="text-xs font-bold uppercase tracking-[0.12em] text-charcoal/70 hover:text-charcoal whitespace-nowrap transition-colors duration-200"
          >
            {l.label}
          </Link>
        ))}
      </div>
    </nav>
  </header>
);

export default Nav;
